import { Platform } from "react-native";

// Detect iOS Safari on web (has bottom navigation bar that reduces available space)
export const isSafari = () => {
  if (Platform.OS !== "web" || typeof window === "undefined") {
    return false;
  }
  const ua = window.navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isSafari = /safari/.test(ua) && !/chrome|crios|fxios/.test(ua);
  return isIOS && isSafari;
};
